export class CategoryExtension {
  static generateGraphRequestFromAssignment(assignment) {
    if (assignment && assignment.id && assignment.classId) {
      return {
        id: assignment.id,
        method: "GET",
        url: `/education/classes/${assignment.classId}/assignments/${assignment.id}/categories`
      };
    }
  }
}
